var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotsure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_758_547)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_758_547",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.558863H49.9999V50.5587H0V0.558863Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_758_547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6183 44.8036C9.69852 44.1138 8.82904 43.3594 8.01641 42.5461C-1.36354 33.1643 -1.36354 17.9535 8.01641 8.57173C16.3227 0.263942 29.1992 -0.687031 38.5517 5.71891",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8235 11.9856C51.2428 21.3415 50.2965 34.2325 41.9845 42.546C37.3342 47.1973 31.2514 49.5426 25.1566 49.5819C24.4722 49.5864 22.9719 49.52 22.2891 49.4662",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.942 23.9654C31.5642 23.9654 30.4473 22.8484 30.4473 21.4702V19.6119C30.4473 18.2339 31.5642 17.1167 32.942 17.1167C34.3198 17.1167 35.4367 18.2339 35.4367 19.6119V21.4702C35.4367 22.8484 34.3198 23.9654 32.942 23.9654Z",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0582 23.9654C15.6804 23.9654 14.5635 22.8484 14.5635 21.4702V19.6119C14.5635 18.2339 15.6804 17.1167 17.0582 17.1167C18.436 17.1167 19.5529 18.2339 19.5529 19.6119V21.4702C19.5529 22.8484 18.436 23.9654 17.0582 23.9654Z",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0527 12.7463C30.475 14.1688 35.0331 14.5442 36.8306 12.7463",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9478 11.1913C19.5256 9.7687 14.9675 9.39341 13.1699 11.1913",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8061 32.4524L19.9122 36.1164C19.5347 36.3095 19.1571 36.5431 18.7813 36.8194L18.7473 36.8443C17.2714 35.1706 14.6387 35.0032 12.9633 36.6087L10.5212 40.4641C10.1429 40.9063 9.91525 41.4575 9.87116 42.0378C9.82707 42.6181 9.96887 43.1973 10.276 43.6916L12.5009 48.6909C13.161 49.753 18.7382 49.4328 22.5766 49.4682C26.5911 49.5052 28.1466 45.1493 26.1039 41.6922C25.6487 40.922 25.2394 40.2925 25.0236 39.928L28.9391 37.494C30.3309 36.6288 30.7581 34.7986 29.893 33.4065C29.0278 32.0143 27.198 31.5872 25.8061 32.4524Z",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7817 36.8194L15.3486 42.0299",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.752 30.8466H18.8308C20.2758 30.8466 21.6959 30.4694 22.9505 29.7523C24.1694 29.0556 25.5451 28.6794 26.9489 28.6589C28.3528 28.6384 29.7389 28.9743 30.9776 29.6351L33.2487 30.8466",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_758_547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.558716)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotsure);
export default __webpack_public_path__ + "static/media/notsure.fcc76f1f3056976a058e277e79707b6b.svg";
export { ForwardRef as ReactComponent };